var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.83301C7.5 11.968 10.865 15.333 15 15.333C19.135 15.333 22.5 11.968 22.5 7.83301C22.5 3.69801 19.135 0.333008 15 0.333008C10.865 0.333008 7.5 3.69801 7.5 7.83301ZM28.3333 31.9997H30V30.333C30 23.9013 24.765 18.6663 18.3333 18.6663H11.6667C5.23333 18.6663 0 23.9013 0 30.333V31.9997H28.3333Z",
    fill: "#0E82FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon1);
export default __webpack_public_path__ + "static/media/price-icon1.2d88bd6393c72947bd52f7dda42935a6.svg";
export { ForwardRef as ReactComponent };